// src/services/cmsService.js

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/api/v2/cms/operations`; 

export const getGovernmentsSuperRoutes = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/governments-super-routes/all`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }); 

    if (!response.ok) {
      throw new Error(`Error fetching governments superRoutes`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("❌ Error en getGovernmentsSuperRoutes:", error);
    return null;
  }
};

// Todas las relaciones ruta <-> linea de una sola vez. Cada fila trae su `superRoute`, y ahi viene
// `govId` / `govName`: la alcaldia dueña de la linea (ELP-1110, columna SuperRoute.surGovId).
// `govId` null = linea INDEPENDIENTE, sin alcaldia.
//
// Reemplaza al par getGovernmentsSuperRoutes + un getRouteSuperRoutesBySuperRoute por linea: con
// esto el filtro por alcaldia es UNA peticion en vez de 1 + N.
export const getAllRouteSuperRoutes = async (token) => {
  try {
    const response = await fetch(`${BASE_URL}/route-super-route/all`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching all RouteSuperRoutes (${response.status})`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("❌ Error en getAllRouteSuperRoutes:", error);
    return null;
  }
};

export const getRouteSuperRoutesBySuperRoute = async (token,surId) => {
  try {
    const response = await fetch(`${BASE_URL}/route-super-route/by-super-route/${surId}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching RouteSuperRoutesBySuperRoute`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("❌ Error en RouteSuperRoutesBySuperRoute:", error);
    return null;
  }
};

export const getBusSchedulesByBusIds = async (token, busIds) => {
  try {
    const response = await fetch(`${BASE_URL}/bus-schedule/by-bus-ids`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(busIds || []),
    });

    if (!response.ok) {
      throw new Error(`Error fetching BusSchedules by busIds (${response.status})`);
    }

    return await response.json();
  } catch (error) {
    console.error("❌ Error en getBusSchedulesByBusIds:", error);
    return null;
  }
};

export const bulkUpsertBusSchedules = async (token, requests) => {
  try {
    const response = await fetch(`${BASE_URL}/bus-schedule/bulk-upsert`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requests || []),
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "");
      throw new Error(`Error bulk-upserting BusSchedules (${response.status}): ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error("❌ Error en bulkUpsertBusSchedules:", error);
    throw error;
  }
};